// extracted by mini-css-extract-plugin
export var button = "_f1-4";
export var hasDarkBackground = "_f1-7";
export var hasLightBackground = "_f1-6";
export var iconWrapper = "_f1-0";
export var large = "_f1-2";
export var medium = "_f1-1";
export var small = "_f1-5";
export var xsmall = "_f1-3";